module.exports = __webpack_public_path__ + "static/img/finddetailshare.efa8ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/community/finddetailshare.png
// module id = HFm+
// module chunks = 1